<blockable-div id="commercial-outage-detail-container" #details>
  <app-progress-spinner [enabled]="isLoading()" />
  <p-blockUI [blocked]="saving() || isLoading()" [target]="details" />
  @if (outage(); as outage) {
    <div id="commercial-outage-details">
      <div id="commercial-outage-details-header">
        <h2 class="commercial-outage-title">
          {{
            (outage.id && outage.CommercialFacility.facilityName) ||
              ('COMMERCIAL_SERVICES.LABEL.NEW_COMMERCIAL_OUTAGE' | translate)
          }}
          @if (outage.outageStartDate) {
            - {{ outage.outageStartDate | date: 'MM/dd/yy' }}
          }
          @if (outage.outageEndDate) {
            - {{ outage.outageEndDate | date: 'MM/dd/yy' }}
          }
        </h2>
        <div class="commercial-outage-actions">
          @if ((outage.id && canEdit()) || (!outage.id && canCreate())) {
            <app-progress-spinner [enabled]="saving()" />
            <button
              pButton
              id="save-btn"
              type="button"
              label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
              icon="fa fa-fw fa-save"
              (click)="saveOutage()"
              [disabled]="!formDirty() || saving()"
            ></button>
          }
        </div>
      </div>
      <hr id="commercial-outage-scroll-divider" />
      <p-scrollPanel class="commercial-outage-scroll-panel">
        @if (formState(); as form) {
          <app-commercial-outage-form
            [form]="form"
            [outage]="outage"
            [availableFacilities]="availableFacilities()"
            [availableAors]="aorOptions()"
            [availableOperatingAreas]="availableOperatingAreas()"
            [availableMarketAreas]="availableMarketAreas()"
            [writeAccess]="outage.id ? canEdit() : canCreate()"
            [validationMessages]="validationMessages"
            (operatingAreaChanged)="onOperatingAreaChange($event)"
            (facilitySelected)="onFacilitySelected($event)"
            (facilityFiltersChanged)="onFacilityFiltersChanged()"
          />
        }
      </p-scrollPanel>
    </div>
  }
</blockable-div>
